import React from "react";
import styles from "./Header3.module.css";

interface Header3Props {
    className?: string;
    children: React.ReactNode;
}

const Header3: React.FC<Header3Props> = ({ children, className }) => {
    return (
        <h3 className={`${styles.header3} ${className || ""}`}>
            {children}
        </h3>
    );
};

export default Header3;
